import { createFileRoute } from '@tanstack/react-router'
import { SerialUnitScreen } from '@/features/inventory-serials/serial-unit-screen'

/** Route shell for one serial-numbered unit and its history (WP11). A child of `serials.tsx`, whose guard already ran. */
export const Route = createFileRoute('/_authenticated/inventory/serials/$unitId')({
  component: SerialUnitRoute,
})

function SerialUnitRoute() {
  const { unitId } = Route.useParams()

  return <SerialUnitScreen unitId={unitId} />
}
